import React, { useMemo } from 'react';
import { SocialIcons } from 'design-system';
import style from './style.module.scss';

export default function TeamMemberSocialIcons({ linkedin, email }) {
    const social = useMemo(() => {
        let icons = [];

        if (linkedin) {
            icons.push({
                kind: 'linkedin',
                url: linkedin,
            });
        }

        if (email) {
            icons.push({
                kind: 'custommail',
                url: `mailto:${email}`,
                pathTransform: 'translate(8px,8px)',
                path: 'M 0 3 L 0 6.40625 L 12 12.40625 L 24 6.40625 L 24 3 Z M 0 8.3125 L 0 21 L 24 21 L 24 8.3125 L 12 14.3125 Z',
            });
        }

        return icons;
    }, [linkedin, email]);

    return social?.length ? (
        <SocialIcons wrapperClassName={style.icons} icons={social} />
    ) : null;
}
